import axios from "axios";

const actionGetAnimalsBirthsConsultation = async ({commit}, payload) => {
  const consultations =  await axios.get(`${process.env.VUE_APP_URL_API}/v1/animals/${payload}/birth_informations`);
  commit("SET_BIRTHS_CONSULTATIONS", consultations.data);
}

const actionUpdateBirth = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/animal_births/${payload.id}/update_information`, payload);
}

const actionUpdateService = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}/update_information`, payload);
}

const actionDeleteService = async (_, payload) => {
  await axios.delete(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}/remove_animal`);
}

export default {
  actionGetAnimalsBirthsConsultation,
  actionUpdateBirth,
  actionUpdateService,
  actionDeleteService
}